import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendUser } from 'src/types/backend';

const QUERY = gql`
  query IntegrationAuthStatus {
    me {
      integrationAuthStatus {
        dataSource
        authState
      }
    }
  }
`;

type Result = Pick<BackendUser, 'integrationAuthStatus'>;

export const queryIntegrationAuthStatus = async () => {
  const result = await executeGqlQuery({ query: QUERY });
  return getSingleProp<Result>(result.data);
};
